<template>
  <div>
    <div class="additional-container">
      <div class="py-3 px-1 pl-c-xl">
        <icon-view
          icon="fas fa-clock"
          icon-background="transparent"
          icon-color="#FF7058"
          icon-size="1.0625rem"
          title="Historial de Documentos"
        />
      </div>
    </div>
    <div v-if="!!result.length">
      <time-line class="mt-4 px-4">
        <time-line-item
          v-for="(item, index) in result"
          :key="index"
          icon="fas fa-file d-flex justify-content-center align-items-center"
        >
          <template #date>
            <label class="history-date-title d-flex justify-content-end">
              Fecha
            </label>
            <label class="history-date-value">
              {{ $formatDate(item.dateOfAction) }}
              {{ $formatDate(item.dateOfAction, $templateDate.hour) }}
            </label>
          </template>
          <div class="mx-auto row px-4 mb-2">
            <div class="col-11 mx-auto row p-0">
              <div class="col-3">
                <label class="info-field-title">Estatus:</label>
                <label class="info-field-value">
                  <span
                    class="dot mr-2"
                    :class="getStatusColor(item.statusId)"
                  />
                  {{ item.status | empty }}
                </label>
              </div>
              <div class="col-3">
                <label class="info-field-title">Nombre del Usuario:</label>
                <label class="info-field-value">
                  {{ item.user | empty }}
                </label>
              </div>
              <div class="col-3">
                <label class="info-field-title">Nombre del Archivo:</label>
                <label class="info-field-value">
                  {{ item.filename | empty }}
                </label>
              </div>
              <div v-if="isConditional(item.statusId)" class="col-3">
                <label class="info-field-title">Fecha de Término:</label>
                <label class="info-field-value">
                  {{ item.documentEndDate | date }}
                </label>
              </div>
            </div>
            <div class="col-1 d-flex justify-content-end align-items-center">
              <action-button
                class="button-action"
                i="fas fa-file-download"
                variant="success"
                @click="getDocument(item)"
              />
            </div>
          </div>
          <div
            v-if="item.comment"
            class="comment-wrapper pl-3 bg-white mx-auto row"
          >
            <div class="col-12 py-2 pl-3">
              <i class="fas fa-info-circle text-orange pl-2 mr-2" />
              <span class="font-16 color-gray-7">
                Comentario:
              </span>
            </div>
            <div class="col-12 comment-box pl-5 mb-2">
              <label class="info-field-value">
                {{ item.comment | empty }}
              </label>
            </div>
          </div>
        </time-line-item>
      </time-line>
      <div
        v-if="showFetchMore"
        class="container-fluid d-flex justify-content-center"
      >
        <action-button
          class="m-4 pr-5 pl-3 mx-auto outline rounded-pill"
          i="fas fa-angle-down pr-2"
          text="Ver más"
          variant="outline-success"
          @click="onFetchMoreHistory"
        />
      </div>
    </div>
    <div v-else class="pb-5">
      <custom-result-not-found text="No cuenta con historial en el sistema." />
    </div>
  </div>
</template>
<script>
import { TimeLine, TimeLineItem } from '@quisit/mipe-timeline';
import CustomResultNotFound from 'custom-result-not-found';
import ActionButton from 'ActionButton';
import IconView from 'icon-view';
import { getDocumentStatusHistory as _getDocumentStatusHistory } from '@/services/provider/provider.api.js';
import { downloadDocumentByAttachmentId as _downloadDocument } from '@/services/common/document.api';
import providerContractDocumentStatus from '@/utils/constants/providerContractDocumentStatus.js';

const DEFAULT_PAGE_SIZE = 3;
const INCREMENT_PAGE_SIZE = 3;

export default {
  name: 'DocumentStatusHistory',
  components: {
    ActionButton,
    IconView,
    CustomResultNotFound,
    TimeLine,
    TimeLineItem,
  },
  props: {
    contractDocumentId: {
      type: Number,
      required: true,
    },
    contractDocumentTypeId: {
      type: Number,
      required: true,
    },
    academicYearId: {
      type: Number,
      required: true,
    },
    companyId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      result: [],
      showFetchMore: false,
      pageSize: DEFAULT_PAGE_SIZE,
    };
  },
  async mounted() {
    await this.onSearchHistory();
  },
  methods: {
    async onSearchHistory(pageIndex = 1) {
      const searchParams = {
        pageIndex,
        pageSize: this.pageSize,
        contractDocumentId: this.contractDocumentId,
        contractDocumentTypeId: this.contractDocumentTypeId,
        academicYearId: this.academicYearId,
        companyId: this.companyId,
      };
      const { data: res } = await _getDocumentStatusHistory(searchParams);
      this.result = [...res.data];
      this.showFetchMore = res.count < res.totalItemCount;
    },
    async onFetchMoreHistory() {
      this.pageSize = this.incrementSize;
      await this.onSearchHistory();
    },
    async getDocument({ documentId }) {
      await _downloadDocument(documentId);
    },
  },
  computed: {
    incrementSize() {
      return this.result.length + INCREMENT_PAGE_SIZE;
    },
    getStatusColor() {
      return (statusId) => {
        switch (statusId) {
          case providerContractDocumentStatus.Pending:
            return 'bg-secondary-44';
          case providerContractDocumentStatus.Submitted:
            return 'bg-yellow';
          case providerContractDocumentStatus.Approved:
            return 'bg-green-light';
          case providerContractDocumentStatus.Denied:
            return 'bg-brown';
          case providerContractDocumentStatus.ConditionalApproved:
            return 'bg-orange-light';
          case providerContractDocumentStatus.ReplacementRequest:
            return 'bg-violet';
          default:
            return 'bg-white';
        }
      };
    },
    isConditional() {
      return (statusId) => {
        return statusId === providerContractDocumentStatus.ConditionalApproved;
      };
    },
  },
};
</script>
<style scoped lang="scss">
@import '@/shared/scss/config/_colors.scss';

.dot {
  height: 14px;
  width: 14px;
  border-radius: 50%;
  display: inline-block;
}
.history-date-title {
  text-align: right;
  margin-bottom: 0px;
  font: 0.75rem Lato;
  letter-spacing: 0px;
  color: map-get($colors, 'secondary-6');
}
.history-date-value {
  font: Bold 1rem Lato;
  text-align: right;
  letter-spacing: 0px;
  color: map-get($colors, 'black');
}
.info-field-title {
  font: 0.875rem Lato;
  letter-spacing: 0px;
  margin: 0;
  color: map-get($colors, 'secondary-6');
}
.info-field-value {
  font: 1rem Lato;
  letter-spacing: 0px;
  color: map-get($colors, 'black');
  display: block;
}
::v-deep .dot {
  box-shadow: none !important;
  margin-right: 4px !important;
}
.button-action {
  width: 35px;
  height: 35px;
}
::v-deep .timeline__content--inner {
  padding: 0.5rem !important;
}
</style>
